// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'

// Internal Dependencies:
import Page from 'views/main/page/Page'

// Redux:
import { setLocale } from 'actions/site'

class Locale extends React.Component {
	componentDidMount() {
		const { match, setLocale } = this.props
		let locale = match.path.replace( /\//g, '' )

		if ( ! locale ) {
			locale = siteData.default_locale
		}

		setLocale( locale )
	}

	componentDidUpdate() {
		this.componentDidMount()
	}

	render() {
		const { match } = this.props

		return (
			<Switch>
				{/* Home */}
				<Route path={ match.path } exact render={ props => (
					<Page home={ true } { ...props } />
				)} />

				{/* Pages */}
				<Route path={ `${match.path}:page` } exact component={ Page } />

				{/* Fallback */}
				<Route component={ Page } />
			</Switch>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		locale: state.site.locale
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		setLocale( locale ) {
			dispatch( setLocale( locale ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Locale )



// WEBPACK FOOTER //
// ./views/main/page/Locale.jsx